import { Customer } from 'services/customer';
import { PagedFilterAndSortedRequest } from 'services/dto';
import { Order, ServiceOrder } from 'services/serviceOrder';
import { GetTenantOutput } from 'services/tenant';

export interface CreateInvoice {
  vat: number;
  amount: number;
  customerId: string;
  dueDate: number;
  registrationNumber: string;
  vin: string;
  orders: string[];
  serviceOrders: ServiceOrder[];
  vinNumber: string | undefined;
  makeModel: string | undefined;
  mileage: number | undefined;
}

export interface UpdateInvoice {
  id: string;
  status: string;
  payment?: string;
  note?: string;
}

export interface ReadyForPickup {
  invoiceId: string;
  sendPush: boolean;
  registrationNumber: string;
}

export interface ChatNotify {
  userId: number;
  chatMessage: string;
  chatTitle: string;
  chatChannel: string | undefined;
}

export interface Invoice {
  id: string;
  registrationNumber: string;
  vin: string;
  number: string;
  status: string;
  note: string;
  vat: number;
  amount: number;
  dueDate: number;
  creationTime: Date;
  lastModificationTime: Date;
  customer: Customer;
  tenantId: number;
  tenant: GetTenantOutput;
  orders: Order[];
  invoicePayments: InvoicePayment[];
  invoiceCredits: InvoiceCredit[];
}

export interface InvoiceCredit {
  invoiceId: string;
  lineItemId: string;
  itemType: string;
  grossAmount: number;
  netAmount: number;
}

export interface InvoicePayment {
  id: string;
  amount: number;
  method: string;
  note: string;
  invoiceId: string;
  creationTime: Date;
  transactionType: TransactionType;
  invoiceCreditNoteId: string;
  createdBy: string;
  reconciled?: boolean;
}

export enum TransactionType {
  Payment = 1,
  Credit = 2,
  RefundRequest = 3,
  RefundPaid = 4,
  BankTransfer = 5,
  OtherPayment = 6,
}

export enum TerminalMode {
  Sale = 1,
  Refund = 2,
}

export interface PagedInvoiceRequest extends PagedFilterAndSortedRequest {
  number?: string;
  status?: string | null;
  startAt?: Date | string;
  endAt?: Date | string;
  customer?: string;
  customerId?: string | undefined;
  registrationNumber?: string;
}

export interface LineItemDto {
  id: string;
  type: string;
  creditAmount: number;
  isVat: boolean;
  name: string;
  creditType: string;
}

export interface CreateInvoiceCreditDto {
  invoiceId: string;
  amount: number;
  note: string;
  vat: number;
  lineItems: LineItemDto[];
  createdBy: string;
}
